module.exports = __webpack_public_path__ + "58feb0b9559dc955abea11391a615c9c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/owl_hoots/eagle_owl_hoot.png
// module id = 3227
// module chunks = 0